import React, { lazy, ReactElement, Suspense, useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import ProtectedRoutes from "./protected";
import storage from "@utils/storage";
import { FullPageSpinner } from "@components/Common/Spinner/FullPageSpinner";
import Landing from "@pages/LandingPage/Landing";
import Header from "@components/Common/Header/Header";
import Footer from "@components/Common/Footer/Footer";
import Passwordsuccessfullyreset from "@pages/PasswordSuccessfullyReset/Passwordsuccessful";
import Dashboard from "@pages/Dashboard/Dashboard";
import Profile from "@pages/Profile/Profile";
import EditOfferApplicants from "@pages/Offers/OffersListing/AllOffers/EditOffers/EditOffers";
import PendingOfferApplicants from "@pages/Offers/PendingOfferApplicants";
import Login from "@pages/Login/Login";
import Signup from "@pages/Signup/Signup";
import VerifyEmailOtp from "@pages/VerifyEmailOTP/VerifyEmailOtp";
import BankDetails from "@pages/BankDetails/BankDetails";
import ForgotPassword from "@pages/ForgotPassword/ForgotPassword";
import ResetPassword from "@pages/ResetPassword/ResetPassword";
import Wallet from "@pages/Wallet/wallet";
import AddMoney from "@pages/Wallet/AddMoney";
import WithdrawMoney from "@pages/Wallet/WithdrawMoney";
import CreateOffer from "@pages/Offers/CreateOffer";
import AllOffers from "@pages/Offers/OffersListing/AllOffers/AllOffers";
import CompletedOffers from "@pages/Offers/OffersListing/CompletedOffers/CompletedOffers";
import ActiveOffers from "@pages/Offers/OffersListing/ActiveOffers/ActiveOffers";
import PendingOffers from "@pages/Offers/OffersListing/PendingOffers/PendingOffers";
import CanceledOffers from "@pages/Offers/OffersListing/CanceledOffers/CanceledOffers";
import ReviewApplication from "@pages/Application/ReviewApplication";
import NotificationList from "@pages/Notification/NotificationList";
import SubmittedApplication from "@pages/Application/ApplicationListing/SubmittedApplications/SubmittedApplications";
import ApprovedApplication from "@pages/Application/ApplicationListing/ApprovedApplications/ApprovedApplications";
import RejectedApplication from "@pages/Application/ApplicationListing/RejectedApplications/RejectedApplications";
import UnderReviewApplication from "@pages/Application/ApplicationListing/UnderReviewApplications/UnderReviewApplications";
import TermsAndConditions from "@pages/TermsAndConditions/TermsAndConditions";
import OtpVerifySuccessfull from "@pages/OtpVerifySuccessfull/OtpVerifySuccessfull";
import ViewApplication from "@pages/Application/ViewApplication";
import BrowseOffers from "@pages/Application/BrowseOffers";
import InReviewOffer from "@pages/Offers/OffersListing/InReviewOffers/InReviewOffers";
import UpdateOffer from "@pages/Offers/UpdateOffer";
import Faq from "@pages/faq/Faq";
import HowItWorks from "@pages/howItWorks/HowItWorks";
import Security from "@pages/security/Security";
import Products from "@pages/products/Products";
import Privacy from "@pages/PrivacyPolicy/Privacy";
import CompletedApplication from "@pages/Application/ApplicationListing/CompletedApplications/CompletedApplications";
import PhoneVerification from "@pages/PhoneVerification/PhoneVerification";
import DocumentVerification from "@pages/DocumentVerification/DocumentVerification";
import ViewTransaction from "@pages/Wallet/ViewTransaction";
import { CreditScoreAssessment } from "@pages/CreditScore/CreditScoreAssessment";
import { getCreditAssessmentStatus } from "../API/CreditScore";
export const Unauthorized = lazy(
  () => import("@pages/Unauthorized/Unauthorized")
);
// export const Login = lazy(() => import("@pages/Login/Login"));
// export const Signup = lazy(() => import("@pages/Signup/Signup"));
// export const VerifyEmailOtp = lazy(
//   () => import("@pages/VerifyEmailOTP/VerifyEmailOtp")
// );
// export const BankDetails = lazy(() => import("@pages/BankDetails/BankDetails"));
// // export const DocumentVerification = lazy(
// //   () => import("@pages/DocumentVerification/DocumentVerification")
// // );

// export const ForgotPassword = lazy(
//   () => import("@pages/ForgotPassword/ForgotPassword")
// );
// export const NotificationList = lazy(
//   () => import("@pages/Notification/NotificationList")
// );
// // export const Dashboard = lazy(() => import("@pages/Dashboard/Dashboard"));
// export const TermsAndConditions = lazy(
//   () => import("@pages/TermsAndConditions/TermsAndConditions")
// );
// export const ResetPassword = lazy(
//   () => import("@pages/ResetPassword/ResetPassword")
// );
// // export const PendingOfferApplicants = lazy(
// //   () => import("@pages/Offers/PendingOfferApplicants")
// // );
// export const BorrowerLendingPage = lazy(
//   () => import("@pages/LendingPages/BorrowerLendingPage")
// );
// export const LenderLendingPage = lazy(
//   () => import("@pages/LendingPages/LenderLendingPage")
// );
// export const AllOffers = lazy(
//   () => import("@pages/Offers/OffersListing/AllOffers/AllOffers")
// );
// export const CompletedOffers = lazy(
//   () => import("@pages/Offers/OffersListing/CompletedOffers/CompletedOffers")
// );
// export const PendingOffers = lazy(
//   () => import("@pages/Offers/OffersListing/PendingOffers/PendingOffers")
// );
// export const ActiveOffers = lazy(
//   () => import("@pages/Offers/OffersListing/ActiveOffers/ActiveOffers")
// );
// export const CanceledOffers = lazy(
//   () => import("@pages/Offers/OffersListing/CanceledOffers/CanceledOffers")
// );

// export const SubmittedApplication = lazy(
//   () =>
//     import(
//       "@pages/Application/ApplicationListing/SubmittedApplications/SubmittedApplications"
//     )
// );
// export const ApprovedApplication = lazy(
//   () =>
//     import(
//       "@pages/Application/ApplicationListing/ApprovedApplications/ApprovedApplications"
//     )
// );
// export const RejectedApplication = lazy(
//   () =>
//     import(
//       "@pages/Application/ApplicationListing/RejectedApplications/RejectedApplications"
//     )
// );
// export const UnderReviewApplication = lazy(
//   () =>
//     import(
//       "@pages/Application/ApplicationListing/UnderReviewApplications/UnderReviewApplications"
//     )
// );
// export const CreateOffer = lazy(() => import("@pages/Offers/CreateOffer"));
// export const ReviewApplication = lazy(
//   () => import("@pages/Application/ReviewApplication")
// );
// export const Wallet = lazy(() => import("@pages/Wallet/wallet"));
// export const AddMoney = lazy(() => import("@pages/Wallet/AddMoney"));
// export const WithdrawMoney = lazy(() => import("@pages/Wallet/WithdrawMoney"));

interface Routes {
  path: string;
  element: ReactElement;
  roles?: string[];
}

const authRoutes: Routes[] = [
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/signup",
    element: <Signup />,
  },
  {
    path: "/auth/verify-otp",
    element: <VerifyEmailOtp />,
  },
  {
    path: "/auth/bank-details",
    element: <BankDetails />,
  },
  {
    path: "/auth/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/auth/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/auth/successfully-reset",
    element: <Passwordsuccessfullyreset />,
  },
  {
    path: "/auth/email-verify-successfully",
    element: <OtpVerifySuccessfull />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/security",
    element: <Security />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/auth/phone-verification",
    element: <PhoneVerification />,
  },
  {
    path: "/auth/document-verification",
    element: <DocumentVerification />,
  },
  {
    path: "/auth/credit-score-assessment",
    element: <CreditScoreAssessment />,
  },
];

const protectedRoutes: Routes[] = [
  {
    path: "/app/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/app/profile",
    element: <Profile />,
  },
  {
    path: "/app/wallet",
    element: <Wallet />,
  },
  {
    path: "/app/add-money",
    element: <AddMoney />,
  },
  {
    path: "/app/withdraw-money",
    element: <WithdrawMoney />,
  },
  {
    path: "/app/create-offer",
    element: <CreateOffer />,
  },
  {
    path: "/app/update-offer",
    element: <UpdateOffer />,
  },
  {
    path: "/app/offer-applications",
    element: <PendingOfferApplicants />,
  },
  {
    path: "/app/edit-offer-applications",
    element: <EditOfferApplicants />,
  },
  {
    path: "/app/view-applications",
    element: <ViewApplication />,
  },
  {
    path: "/app/all-offers",
    element: <AllOffers />,
  },
  {
    path: "/app/browse-offers",
    element: <BrowseOffers />,
  },
  {
    path: "/app/completed-offers",
    element: <CompletedOffers />,
  },
  {
    path: "/app/open-offers",
    element: <ActiveOffers />,
  },
  {
    path: "/app/in-review-offers",
    element: <InReviewOffer />,
  },
  {
    path: "/app/approved-offers",
    element: <PendingOffers />,
  },
  {
    path: "/app/canceled-offers",
    element: <CanceledOffers />,
  },
  {
    path: "/app/review-offer",
    element: <ReviewApplication />,
  },
  {
    path: "/app/view-transaction",
    element: <ViewTransaction />,
  },
  {
    path: "/app/notification",
    element: <NotificationList />,
  },
  {
    path: "/app/submitted-applications",
    element: <SubmittedApplication />,
  },
  {
    path: "/app/approved-applications",
    element: <ApprovedApplication />,
  },
  {
    path: "/app/rejected-applications",
    element: <RejectedApplication />,
  },
  {
    path: "/app/underReview-applications",
    element: <UnderReviewApplication />,
  },
  {
    path: "/app/completed-applications",
    element: <CompletedApplication />,
  },
];

const publicRoutes: Routes[] = [
  {
    path: "/terms-and-conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/privacy-policy",
    element: <Privacy />,
  },
  {
    path: "/header",
    element: <Header handleMenuToggle={handleMenuToggle} />,
  },
  {
    path: "/footer",
    element: <Footer />,
  },
  {
    path: "/",
    element: <Landing />,
  },
];

export default function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const isUserLogedIn = !!storage.getToken();
  const navigatePath = isUserLogedIn ? "/app/dashboard" : "/auth/login";

  useEffect(() => {
    if (
      ![...protectedRoutes, ...authRoutes, ...publicRoutes]
        .map((item) => item.path)
        .includes(location.pathname)
    ) {
      navigate(navigatePath);
    }
  }, [isUserLogedIn]);

  useEffect(() => {
    if (isUserLogedIn) return;

    const earlyOnboardingPaths = [
      "/auth/signup",
      "/auth/phone-verification",
      "/auth/document-verification",
      "/auth/verify-otp",
      "/auth/credit-score-assessment",
    ];

    if (earlyOnboardingPaths.includes(location.pathname)) return;

    const storedUser = storage.getUserType();
    const userId =
      storedUser?.uuid || storedUser?.data?.uuid || storedUser?.userId;
    const userRole = storedUser?.userType || storedUser?.data?.userType || "borrower";

    if (!userId || userRole === "lender") return;

    getCreditAssessmentStatus(userId)
      .then((res) => {
        if (!res.data.isCreditAssessment) {
          navigate("/auth/credit-score-assessment", {
            state: {
              roleType: storedUser?.userType ?? "borrower",
              userData: storedUser,
            },
          });
        }
      })
      .catch(() => {
        // Status check is best-effort; login/signup guards handle enforcement
      });
  }, [isUserLogedIn, location.pathname, navigate]);

  return (
    <Routes>
      {publicRoutes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
      <Route>
        {authRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              isUserLogedIn ? <Navigate to={"/app/dashboard"} /> : route.element
            }
          />
        ))}
        <Route path="/auth" element={<Navigate to={navigatePath} />} />
      </Route>
      {isUserLogedIn ? (
        <Route element={<ProtectedRoutes />}>
          {protectedRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                isUserLogedIn ? (
                  <Suspense fallback={<FullPageSpinner />}>
                    {route.element}
                  </Suspense>
                ) : (
                  <Navigate to={"/auth/login"} replace={true} />
                )
              }
            />
          ))}
          <Route path="/app" element={<Navigate to={navigatePath} />} />
        </Route>
      ) : null}
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<Navigate to={navigatePath} />} />
    </Routes>
  );
}
function handleMenuToggle(): void {
  throw new Error("Function not implemented.");
}
